import {useAppDispatch} from '../../../../hook/store';
import {useState} from 'react';
import {useForm} from 'react-hook-form';
import {SpecificationItemActionData, SpecRenameRequest} from '../../../../interface';
import {renameSpecification} from '../../../../store/slice/spec-slice';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormGroup,
    TextField
} from '@mui/material';
import {LoadingButton} from '@mui/lab';


interface RenameDialogProps {
    specification: SpecificationItemActionData;
    onClose: () => void;
}

const RenameDialog = ({specification: {item}, onClose}: RenameDialogProps) => {
    const dispatch = useAppDispatch();
    const [inProgress, setInProgress] = useState<boolean>(false);
    const {
        register,
        formState: {errors, isValid},
        handleSubmit,
    } = useForm({
        mode: 'all'
    });

    const onSubmit = async (formData: any) => {
        if (!item?.id) {
            return;
        }
        setInProgress(true);
        const data: SpecRenameRequest = {
            id: item.id,
            data: formData
        };
        await dispatch(renameSpecification(data)).unwrap()
            .then((data: any) => {
                if(!data.error) {
                    onClose();
                }
            })
            .catch((error) => {
                setInProgress(false);
                onClose();
            });
        window.location.reload();
    };


    return <>
        <Dialog
            className="rename-dialog"
            open={true}
            fullWidth={true}
            maxWidth={'sm'}
            onClose={onClose}
        >
            <DialogTitle className="dialog-title">Переименование спецификации</DialogTitle>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogContent>
                    <FormGroup className={errors?.message ? 'form-field form-field-error' : 'form-field'}>
                        <FormControl>
                            <TextField {...register('name', {
                                value: item?.name || '',
                                required: 'Обязательное поле',
                                maxLength: {value: 100, message: 'Название должно содержать максимум 100 символов'}
                            })}
                                       multiline
                                       rows={3}
                                       variant="outlined"
                                       error={!!errors?.name}
                                       helperText={errors?.name ? errors?.name.message as string : ''}

                            />
                        </FormControl>
                    </FormGroup>

                </DialogContent>
                <DialogActions className="form-buttons">
                    <Button
                        variant={'outlined'}
                        onClick={onClose}
                        disabled={inProgress}
                    >
                        Отмена
                    </Button>
                    <LoadingButton
                        loading={inProgress}
                        type={'submit'}
                        variant={'contained'}
                        disabled={!isValid || inProgress}
                    >
                        Сохранить
                    </LoadingButton>
                </DialogActions>
            </form>

        </Dialog>
    </>;
};

export {RenameDialog};
